import React, {Component} from 'react';
import {Popconfirm, Button, message, Modal, Input, Checkbox} from 'antd';
import axios from 'axios'
import {connect} from 'react-redux'
import API from '../../../../API/api'
const CheckboxGroup = Checkbox.Group;
const plainOptions = [
    {label: '格式不对', value: '格式不对'},
    {label: '内容不对', value: '内容不对'},
    {label: '答案有误', value: '答案有误'},
    {label: '题型有误', value: '题型有误'},
    {label: '其他', value: '其他'}
]

class Question extends Component {
    state = {
        reworkModal: false,
        mark: '',
        reworkMessage: [],
    }
    //修改
    handleModify = () => {
        let question_id = this.props.question.question_id
        // this.context.router.history.push()
        window.open(window.location.origin + `/question.html#/${window.location.href.split('/').pop()}/fillin/${question_id}`)
    }
    //删除
    handleDel = () => {
        let {refresh} = this.props
        let question_id = this.props.question.question_id
        let data = {
            task_id: window.location.href.split('/').pop(),
            question_id: ~~question_id,
            is_search: 0
        }
        axios.post(API.DEL_QUESTION, data).then((res) => {
            res = res.data
            if (res.code === 0) {
                message.success('删除成功')
                refresh()
            } else {
                message.error(res.message);
            }
        }, (error) => {
            message.error('网络错误！');
        });
    }
    //返工
    handleRework = () => {
        let reworkMessage = this.state.reworkMessage
        let mark = this.state.mark
        if ((!reworkMessage.length)&&mark === '') {
            message.error('请选择或填写返工原因')
            return
        }

        let {refresh} = this.props
        let question_id = this.props.question.question_id
        let data = {
            task_id: window.location.href.split('/').pop(),
            question_id: ~~question_id,
            is_search: 0,
            mark: `${reworkMessage.join(',')},${mark}`,
        }
        axios.post(API.CHECK_REWORK_QUESTION, data).then((res) => {
            res = res.data
            if (res.code === 0) {
                message.success('返工成功')
                refresh()
            } else {
                message.error(res.message);
            }
        }, (error) => {
            message.error('网络错误！');
        });
        this.setState({reworkModal: false, mark: '', reworkMessage: []})
    }
    //审核通过
    handlePass = () => {
        let {refresh} = this.props
        let question_id = this.props.question.question_id
        let data = {
            task_id: window.location.href.split('/').pop(),
            question_id: ~~question_id,
            is_search: 0
        }
        axios.post(API.CHECK_PASS_QUESTION, data).then((res) => {
            res = res.data
            if (res.code === 0) {
                message.success('审核通过成功')
                refresh()
            } else {
                message.error(res.message);
            }
        }, (error) => {
            message.error('网络错误！');
        });
    }

    //返工原因
    onChangeMark = (e) => {
        this.state.mark = e.target.value
    }
    checkboxChange = (checkedValues) => {
        this.setState({
            reworkMessage: checkedValues
        })
    }
    render() {
        let role_qbox = this.props.user.role_qbox
        if(!role_qbox){return null}
		
        let question = this.props.question
        //任务不等于入库中，入库失败，已入库，审核中阶段是才能编辑和删除题目
        let editDel = this.props.current!=='online_success'
                        && this.props.current!=='online_fail'
                            && this.props.current!=='online_ing'
                            //&& this.props.current!=='checking'
        return (
            <div style={{position: 'absolute', top: '50px', right: '40px'}}>
                {this.props.isVerify &&
                <div>
                    {
                        role_qbox.buttons.questionCheckPass === 1 &&
                        question.stage_name !== '审核通过' &&
                        <Popconfirm title="确认合格吗？" onConfirm={() => this.handlePass()} okText="确认" cancelText="取消">
                            <Button style={{display: 'block', marginBottom: 10}}>合格</Button>
                        </Popconfirm>
                    }
                    {
                        role_qbox.buttons.questionCheckRework === 1 &&
                        question.stage_name !== '返工' &&
                        <Button style={{display: 'block', marginBottom: 10}}
                                onClick={() => this.setState({reworkModal: true})}>返工</Button>
                    }
                    <Modal title="返工原因" visible={this.state.reworkModal} onOk={this.handleRework}
                           onCancel={() => this.setState({reworkModal: false})}>
                        <CheckboxGroup options={plainOptions} onChange={this.checkboxChange}/>

                        <Input.TextArea rows={3} style={{margin: '10px 0'}} onChange={this.onChangeMark}/>
                    </Modal>
                </div>
                }
                {
                    editDel&&
                    role_qbox.buttons.questionModify === 1 &&
                    <Button onClick={() => this.handleModify()} style={{display: 'block', marginBottom: 10}}>修改</Button>
                }
                {
                    editDel&&
                    role_qbox.buttons.questionDel === 1 &&
                    <Popconfirm title="确认删除吗？" onConfirm={() => this.handleDel()} okText="确认" cancelText="取消">
                        <Button style={{display: 'block', marginBottom: 10}}>删除</Button>
                    </Popconfirm>
                }
            </div>
        )
    }
}

const mapStateTopProps = (state) => {
    return {
        user: state.user,
        current:state.questionBox.missionList.current
    };
}
const mapDispatchToProps = dispatch => {
    return {}
};
export default connect(mapStateTopProps, mapDispatchToProps)(Question)



// WEBPACK FOOTER //
// ./src/entry_app/question_box/mission_detail/editDel/view.js